import { EvokeInitializers } from "react-evoke";
import { AppState } from "../typings/AppState";

export const initializers: EvokeInitializers<AppState> = {
  auth: "getMe",
  users: "getUsers",
  user: "getUser",
  posUsers: "getPosUsers",
  roles: "getRoles",
  rolesForUser: "getRolesForUser",
  division: "getDivision",
  status: "getStatus",
  reasons: "getItemReturnReasons",
  itemsList: "getItemReturnDetails",
  terminals: "getTerminals",
  loggedPosUsers: "getLoggedPosUsers",
  permissions: "getPermissions",
  userTypes: "getUserTypes",
  departments: "getDepartments",
  creditCustomers: "getCreditCustomers",
  eods: "getEods",
  posConfigurations: "getPosConfigurations",
  storeConfigurations: "getStoreConfigurations",
  departmentsChart: "getDepartmentChart",
  weeklySales: "getWeeklySales",
  salesReportData: "getSalesReportData",
  dailySales: "getDailyReportData",
  companyDetails: "getCompanyDetails",
  userDivisions: "getUserDivision",
  storeDetails: "getStoreDetails",
  vouchers: "getVouchers",
  currency: "getCurrency",
  service: "getServiceList",
  tablesofService: "getTablesForService",
  resync: "resyncTables",
  configurations: "getConfigurationsList",
};
